import React from 'react';
import PostType from 'layouts/PostType';
import { PageProps } from 'types/page';

/**
 * Promoted Page
 *
 * Displays all posts with type "Promoted" in a grid layout with pagination.
 * Route: /type/promoted
 *
 * @param props - Page props from Next.js
 * @returns PostType layout component with Promoted type
 */
const PromotedPostsPage = (props: PageProps) => {
  return <PostType {...props} type={'Promoted'} />;
};

export default PromotedPostsPage;
